import { render, staticRenderFns } from "./PromoItemsTable.vue?vue&type=template&id=cc61a744&scoped=true&"
import script from "./PromoItemsTable.vue?vue&type=script&lang=js&"
export * from "./PromoItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./PromoItemsTable.vue?vue&type=style&index=0&id=cc61a744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc61a744",
  null
  
)

export default component.exports